export default "__VITE_ASSET__Bd8o8v$Y__"